<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-bug me-2"></i> Bug Report #{{ report?.bugReportId }}</h4>
      </div>
      @if (report) {
        <div class="modal-body">
          <table class="table table-bordered table-sm mb-0">
            <tbody>
              <tr>
                <th style="width: 160px">User</th>
                <td>
                  {{ getDisplayName(report) }}
                  <a class="btn btn-sm btn-primary ms-2"
                     routerLink="/backoffice/management/user-details"
                     [queryParams]="{ id: report.userId }"
                     target="_blank"
                     tooltip="User details"
                     placement="top">
                    <i class="fa fa-search"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <th>Locale</th>
                <td>
                  <svg cIcon [name]="getLocaleFlagIconName(report.userLocale)" class="me-1" style="width:20px; height:15px;"></svg>
                  {{ report.userLocale }}
                </td>
              </tr>
              <tr>
                <th>Mail</th>
                <td>{{ report.mail || '-' }}</td>
              </tr>
              <tr>
                <th>Type</th>
                <td>{{ getBugTypeName(report.bugType) }}</td>
              </tr>
              <tr>
                <th>Rating</th>
                <td>
                  @for (star of [1,2,3,4,5]; track star) {
                    <i class="fa" [class.fa-star]="star <= report.rate" [class.fa-star-o]="star > report.rate" style="color: #f5a623;"></i>
                  }
                  <span class="ms-1 text-muted">({{ report.rate }}/5)</span>
                </td>
              </tr>
              <tr>
                <th>Status</th>
                <td>
                  @if (report.isClosed) {
                    <span class="badge bg-danger">Closed</span>
                  } @else {
                    <span class="badge bg-success">Open</span>
                  }
                  @if (report.shopBuyCredits && report.shopBuyCredits > 0) {
                    <span class="badge bg-warning text-dark ms-1" [tooltip]="report.shopBuyCredits + ' credits'" placement="top">VIP</span>
                  }
                </td>
              </tr>
              <tr>
                <th>Date</th>
                <td>{{ dateService.getDateFromatted(report.createdAtTimestamp) }}</td>
              </tr>
              <tr>
                <th>Description</th>
                <td style="white-space: pre-wrap;">{{ report.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      }
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>
